<!-- events-table.component.html -->
<div class="mat-elevation-z8">

    @if (nextEvent?.date) {
      <div class="mb-4">
      <h3>Next Event</h3>

      <table mat-table [dataSource]="[nextEvent]" class="full-width-table">
        <!-- Event Date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef> Event Date </th>
          <td mat-cell *matCellDef="let element"> {{ element?.date }} </td>
        </ng-container>

        <!-- Event Time Column -->
        <ng-container matColumnDef="time">
          <th mat-header-cell *matHeaderCellDef> Event Time </th>
          <td mat-cell *matCellDef="let element"> {{ element?.time }} </td>
        </ng-container>

        <!-- Expected Column -->
        <ng-container matColumnDef="expected">
          <th mat-header-cell *matHeaderCellDef> Expected Usage (kWH)</th>
          <td mat-cell *matCellDef="let element"> {{ element?.expectedUsage }} </td>
        </ng-container>

        <!-- Max Savings Column -->
        <ng-container matColumnDef="maxSavings">
          <th mat-header-cell *matHeaderCellDef> Max Savings (&pound;) </th>
          <td mat-cell *matCellDef="let element"> {{ element?.maxSavings }} </td>
        </ng-container>

        <!-- Earnings per kW Column -->
        <ng-container matColumnDef="earningsPerKW">
          <th mat-header-cell *matHeaderCellDef> Earnings per kW (&pound;) </th>
          <td mat-cell *matCellDef="let element"> {{ element?.earningsPerKW }} </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let element">
        <button mat-flat-button [disabled]="tpi" color="primary" *ngIf="element?.status === eventStatus.OPTED_IN" (click)="manageOpting(element, false)">Opt out</button>
        <button mat-flat-button [disabled]="tpi" color="primary" *ngIf="element?.status === eventStatus.OPTED_OUT" (click)="manageOpting(element, true)">Opt in</button>
          </td>
        </ng-container>

        <!-- Calculator Column -->
        <ng-container matColumnDef="calculator">
          <th mat-header-cell *matHeaderCellDef>Savings Calculator </th>
          <td mat-cell *matCellDef="let element">
        <button mat-raised-button color="primary" (click)="openSavingsCalculator(element)">Open</button>
          </td>
        </ng-container>

        <!-- Header and Row Declarations -->
        <tr mat-header-row *matHeaderRowDef="['date', 'time', 'expected', 'maxSavings', 'earningsPerKW', 'actions', 'calculator']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['date', 'time', 'expected', 'maxSavings', 'earningsPerKW', 'actions', 'calculator'];"></tr>
      </table>
    </div>
    }


    <h3>Event Details</h3>

    <!-- Optional: Filter Input -->
    <!-- <div class="filter">
      <mat-form-field>
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Status">
      </mat-form-field>
    </div> -->
  
    <table mat-table [dataSource]="dataSource" matSort class="full-width-table">
  
      <!-- EventDate Column -->
      <ng-container matColumnDef="EventDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Event Date </th>
        <td mat-cell *matCellDef="let element"> {{element.EventDate}} </td>
      </ng-container>
  
      <!-- EventFromTime Column -->
      <ng-container matColumnDef="EventFromTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> From Time </th>
        <td mat-cell *matCellDef="let element"> {{element.EventFromTime}} </td>
      </ng-container>
  
      <!-- EventEndTime Column -->
      <ng-container matColumnDef="EventEndTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> End Time </th>
        <td mat-cell *matCellDef="let element"> {{element.EventEndTime}} </td>
      </ng-container>
  
      <!-- MeterNo Column -->
      <ng-container matColumnDef="MeterNo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Meter No </th>
        <td mat-cell *matCellDef="let element"> {{element.MeterNo}} </td>
      </ng-container>
  
      <!-- Expected Column -->
      <ng-container matColumnDef="Expected">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Expected </th>
        <td mat-cell *matCellDef="let element"> {{element.Expected}} </td>
      </ng-container>
  
      <!-- Actual Column -->
      <ng-container matColumnDef="Actual">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Actual </th>
        <td mat-cell *matCellDef="let element"> {{element.Actual}} </td>
      </ng-container>
  
      <!-- Savings Column -->
      <ng-container matColumnDef="Savings">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Savings </th>
        <td mat-cell *matCellDef="let element"> {{element.Savings}} </td>
      </ng-container>
  
      <!-- Earnings Column -->
      <ng-container matColumnDef="Earnings">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Earnings </th>
        <td mat-cell *matCellDef="let element"> {{element.Earnings}} </td>
      </ng-container>
  
      <!-- ReductionPercent Column -->
      <ng-container matColumnDef="ReductionPercent">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Reduction (%) </th>
        <td mat-cell *matCellDef="let element"> {{element.ReductionPercent}}% </td>
      </ng-container>
  
      <!-- Status Column -->
      <ng-container matColumnDef="Status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
        <td mat-cell *matCellDef="let element"> {{element.Status}} </td>
      </ng-container>
  
      <!-- Header and Row Declarations -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <!-- No Data Row -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data-row" [attr.colspan]="displayedColumns.length">
          No events found.
        </td>
      </tr>
  
    </table>
  
    <!-- Paginator -->
    <mat-paginator [pageSizeOptions]="[10]" showFirstLastButtons></mat-paginator>
    
  </div>
  